// export default function (axios, Api, parameter) {
//     return axios(Api.type, Api.url, parameter || {})
// }
export default function getData(promise, option) {
  return promise.then(async (res) => {
    const data = res.data
    return data
  }).catch(function (err) {
    if (err && err.response) {
      const status = {
        400: {
          message: '请求错误'
        },
        401: {
          message: '未经授权'
        },
        403: {
          message: '拒绝访问'
        },
        404: {
          message: '错误请求地址'
        },
        408: {
          message: '请求超时'
        },
        500: {
          message: '服务器内部错误'
        },
        501: {
          message: '服务未实现'
        },
        502: {
          message: '网关错误'
        },
        503: {
          message: '服务不可用'
        },
        504: {
          message: '网关超时'
        },
        505: {
          message: '不支持Http版本'
        },
        default: {
          message: '未知错误'
        }
      }
    }

    err.isOk = false
    // 请求状态 请求未发送成功
    err.requestFail = false
    return err
  })
}


// WEBPACK FOOTER //
// ./src/utils/request/request.js